<template>
  <TooltipWrapper>
    <template #trigger>
      <span :data-testid="`review-interaction-${type}`">
        <ReviewInteractionStatusIcon :type="type" />
      </span>
    </template>
    <template v-if="text" #content>
      <div class="max-w-xs">{{ text }}</div>
    </template>
  </TooltipWrapper>
</template>

<script setup lang="ts">
import { TooltipWrapper } from '@ramp106/omrjs-core-ui'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

import ReviewInteractionStatusIcon from './ReviewInteractionStatusIcon.vue'
import { ReviewInteractionType } from './types'

const props = defineProps<{
  type: ReviewInteractionType
  subject: 'product' | 'agency'
  tooltipText?: string
}>()

const { t } = useI18n()

const text = computed(() => {
  switch (props.type) {
    case ReviewInteractionType.REMINDER:
      return t(`Reviews.${props.subject}.review.noRemindersStatusHint`)
    case ReviewInteractionType.REMINDER_CHECK:
      return props.tooltipText || ''
    case ReviewInteractionType.REPLY:
      return t(`Reviews.${props.subject}.review.noRepliesStatusHint`)
    case ReviewInteractionType.REPLY_CHECK:
      return props.tooltipText || t(`Reviews.${props.subject}.review.replyStatusHint`)
    default:
      return ''
  }
})
</script>
